﻿import $ from 'jquery';
import _ from 'underscore'
declare global {
  interface JQuery {
    transformtexttolink: (options, args) => any;
  }
}

  export class TransformTextToLink {
    public static get wireup(): string { return '[data-transform-text-to-link]'; }

    private static mutationConfig: MutationObserverInit = {
      childList: true,
      subtree: true
    };

    public static createLink($element: JQuery, options: ICreateLink) {
      if (!$element || $element.length != 1)
        throw new Error('You must provide a single element to Rustig.TransformTextToLink');

      options = $.extend({}, $element.data(), options);

      if (!options.regex || !options.url)
        return;

      if ($element.is('[data-remote]')) {
        options.isRemote = true;
        $element.on('click.rustig.remote', function (e) {
          if (e.target == this)
            e.stopImmediatePropagation();
        });
      }

      this.configureMutationObserver($element, options, this.tryApplyLink.bind(this));
      this.tryApplyLink($element, $element[0], options);
    }

    public static tryApplyLink($element: JQuery, node: any, options: ICreateLink) {
      let observer = <MutationObserver>$element.data('transform-text-to-link-observer');
      try {
        observer.disconnect();
        this.applyLink(node, options);
      }
      finally {
        observer.observe($element[0], this.mutationConfig);
      }
    }

    public static applyLink(node: Node, options: ICreateLink): number {
      if (node instanceof Text) {
        let regex = typeof (options.regex) === 'string' ? new RegExp(<string>options.regex) : <RegExp>options.regex;
        let index = node.data.search(regex);
        if (index >= 0 && node.data.length > 0) {
          var match = node.data.match(regex);

          if (!match)
            return;

          var aNode = document.createElement('a');
          if (options.isRemote)
            aNode.setAttribute('data-url', options.url)
          else
            aNode.setAttribute('href', options.url);
          if (options.target)
            aNode.setAttribute('target', options.target);

          let aNodeText = node.splitText(index);
          aNodeText.splitText(match[0].length);

          let aNodeTextClone = aNodeText.cloneNode(true);
          aNode.appendChild(aNodeTextClone);

          if (aNodeText.parentNode) {
            aNodeText.parentNode.replaceChild(aNode, aNodeText);
          } else {
            node.parentNode.insertBefore(aNode, node.nextSibling);
          }

          let skipNewlyCreatedNodes = 2;
          return skipNewlyCreatedNodes;
        }
      }
      else if (node instanceof HTMLElement) {
        let hasChildNodes = node.childNodes;
        let isStyleOrScriptElement = /(script|style)/i.test(node.tagName);
        if (hasChildNodes && !isStyleOrScriptElement) {
          for (let i = 0; i < node.childNodes.length; i++) {
            i += this.applyLink(node.childNodes[i], options);
          }
        }
      }
      return 0;
    }

    private static configureMutationObserver($element: JQuery, options: ICreateLink, nodeAddedHandler: ($element: JQuery, node: any, options: ICreateLink) => void): void {
      if ($element.data('transform-text-to-link-observer'))
        return;

      const callback: MutationCallback = (mutationsList: MutationRecord[]) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList' && mutation.addedNodes.length) {

            mutation.addedNodes.forEach((node) => {
              nodeAddedHandler($element, node, options);
            });
          }
        }
      }

      const observer = new MutationObserver(callback);

      $element.data('transform-text-to-link-observer', observer);
      observer.observe($element[0], this.mutationConfig);
    }
  }

  export interface ICreateLink {
    regex: string | RegExp;
    url: string;
    isRemote?: boolean;
    target?: string;
  }

  function Plugin(option, args) {
    return this.each(function () {
      TransformTextToLink.createLink($(this), option);
    });
  }

$.fn.transformtexttolink = Plugin;
